export default __webpack_public_path__ + "static/media/embrace_logo_grey_2.f6a8727f.png";